import Papa from 'papaparse'

/**
 * Export tabular data to a CSV file and trigger a download.
 * @param data - Row/column values to export
 * @param fileName - Base filename without extension
 */
export function exportCsv(data: (string | number)[][], fileName = 'data') {
  downloadFile({
    fileName: `${fileName}.csv`,
    fileDataString: Papa.unparse(data),
  })
}

export function downloadFile({
  fileName,
  fileDataType = 'data:text/plain;charset=utf-8',
  fileDataString,
}: {
  fileDataType?: string
  fileDataString: string
  fileName: string
}) {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    [fileDataType, encodeURIComponent(fileDataString)].join(),
  )
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
